module.exports = __webpack_public_path__ + "static/img/yd-banner3.cb18a08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yd-banner3.png
// module id = dCh7
// module chunks = 0